import {$http} from '@/utils/https'
import {STREAMS_ITEM_REQUEST_STATUS, STREAMS_REQUEST_STATUS, STREAMS_SET_ITEM,} from './types/mutation-types';

import {FETCH_STREAMS_ITEM} from './types/action-types';


const state = {
    list: null,
    currentItem: null,
    isListLoading: false,
    isCurrentItemLoading: false,
    skip: 0,
    limit: 9,
    listLength: 0,
};

const getters = {
    list: state => state.list,
    currentItem: state => state.currentItem,
    listLength: state => state.listLength,
    skip: state => state.skip,
    isListLoading: state => state.isListLoading,
    isCurrentItemLoading: state => state.isCurrentItemLoading,
};

const actions = {
    [FETCH_STREAMS_ITEM]: async ({commit}, payload) => {
        try {
            commit(STREAMS_ITEM_REQUEST_STATUS, true);
            commit(STREAMS_SET_ITEM, null);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_COURSE}courses/${payload.item}/live-stream?include=seo,speakers&use_as_id=slug`);
            commit(STREAMS_SET_ITEM, null);
            commit(STREAMS_SET_ITEM, response.data.data[0]);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(STREAMS_ITEM_REQUEST_STATUS, false);
        }
    },
};

const mutations = {
    [STREAMS_SET_ITEM](state, data) {
        state.currentItem = data;
    },
    [STREAMS_REQUEST_STATUS](state, status) {
        state.isListLoading = status;
    },
    [STREAMS_ITEM_REQUEST_STATUS](state, status) {
        state.isCurrentItemLoading = status;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
